fx.ns("common.popups", class CoverChanged extends shared.popups.BasePersonPopup{

    // mode : edition / preview
    constructor(mode)
    {
        super(null, fx.get("assets").personSure);

        this._mode = mode;
        this.contentWidth = 510;
        this.contentHeight = this._mode == "edition" ? 205 : 160;
        this.showClose = true;
    }
  

    create()
    {
        super.create();
        this.title = new fx.components.Text({text:fx.text("La couverture a été changée"), className:"title center"});
        this.addChild(this.title);

        if (this._mode == "edition")
        {
            this.text = new fx.components.Text({text:fx.text("Vérifier que tout est placé correctement sur votre couverture."), className:"text center"});
            this.addChild(this.text);
        }
        else
        if (this._mode == "force")
        {
            this.text = new fx.components.Text({text:fx.text("La taille de votre album ne permettait pas de garder la même couverture."), className:"text center"});
            this.addChild(this.text);
        }

        this.okButton = new fx.components.Button({label : fx.text("Ok"), type : "filled"});
        
        this.addFooterChild(this.okButton, {width : 250});
    
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.okButton);

    }

    destroy()
    {
        super.destroy();

        this.title.destroy();
        this.okButton.destroy();
    }


});
